import type { IntlShape } from 'react-intl';
import { formatTranslation } from 'intl';
import { DocumentationTranslationKeys } from 'intl/keys';
import type { DocumentationModel } from 'shared/domain/documentation/documentationModel';
import { findCurrentVersion } from 'shared/domain/documentation/currentVersion';
import { formatVersionNumber } from 'shared/domain/documentation/versionState';

/**
 * What a documentation row of the export/import browser tells under its name (PT-7117 mockup).
 * It reads only the versions and the current one, so a row recomputes it only when those change.
 */
export function documentationRowCaption(
  intl: IntlShape,
  documentation: Pick<DocumentationModel, 'versions' | 'currentVersionId'>
): string {
  const currentVersionNumber = formatVersionNumber(findCurrentVersion(documentation)?.number);
  if (currentVersionNumber) {
    return formatTranslation(intl, DocumentationTranslationKeys.browserCurrentVersion, {
      version: currentVersionNumber,
    });
  }
  if (documentation.versions.some((version) => !version.deleted)) {
    return formatTranslation(intl, DocumentationTranslationKeys.browserNoCurrentVersion);
  }
  return formatTranslation(intl, DocumentationTranslationKeys.browserNoVersions);
}
